import * as React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';

const alertMessage = (props) => {
  // const styles1 = theme => ({
  //   success: {
  //     backgroundColor: green[600],
  //   },
  //   error: {
  //     backgroundColor: theme.palette.error.dark,
  //   },
  //   info: {
  //     backgroundColor: theme.palette.primary.dark,
  //   },
  //   warning: {
  //     backgroundColor: amber[700],
  //   },
  //   icon: {
  //     fontSize: 20,
  //   },
  //   iconVariant: {
  //     opacity: 0.9,
  //     marginRight: theme.spacing.unit,
  //   },
  //   message: {
  //     display: 'flex',
  //     alignItems: 'center',
  //   },
  // });

  // type: primary, secondary, success, danger, warning, info, light, dark
  return (
    <div className={`alert alert-${props.type ? props.type : 'primary'}`} role="alert">
      <div dangerouslySetInnerHTML={{ __html: props.children }} />
    </div>

    // <Snackbar
    //   anchorOrigin={{
    //     vertical: 'bottom',
    //     horizontal: 'left',
    //   }}
    //   open={props.isVisible}
    //   autoHideDuration={2000}
    //   onClose={props.handleClose}
    // >
    //   <SnackbarContent
    //     // 'success', 'warning', 'error', 'info'
    //     className={props.type ? props.type : 'error'}
    //     aria-describedby="client-snackbar"
    //     message={
    //       <span id="client-snackbar" className={props.type ? props.type : 'error'}>
    //         {props.message}
    //       </span>
    //     }
    //     action={[
    //       <IconButton
    //         key="close"
    //         aria-label="Close"
    //         color="inherit"
    //         onClick={props.handleClose}
    //       >
    //         <CloseIcon />
    //       </IconButton>,
    //     ]}
    //   />
    // </Snackbar>


    // <Snackbar
    //   anchorOrigin={{
    //     vertical: 'bottom',
    //     horizontal: 'left',
    //   }}
    //   open={props.isVisible}
    //   autoHideDuration={6000}
    //   onClose={props.handleClose}
    //   ContentProps={{
    //     'aria-describedby': 'message-id',
    //   }}
    //   message={<span id="message-id">{props.message}</span>}    
    //   action={[
    //     // <Button key="undo" color="secondary" size="small" onClick={this.handleClose}>
    //     //   UNDO
    //     // </Button>,
    //     <IconButton
    //       key="close"
    //       aria-label="Close"
    //       color="inherit"
    //       onClick={props.handleClose}
    //     >
    //       <CloseIcon />
    //     </IconButton>,
    //   ]}
    // />
  )
}

export default alertMessage;